export default __webpack_public_path__ + "static/media/Settings.f860c885.svg";